export const TableCell = ({ index, column, value, isMobile }) => {
  return (
    <td key={`${index}-${column}`} className="gray">
      {isMobile && <strong>{column}:</strong>}
      <span>{value}</span>
    </td>
  );
};
